var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicSpeaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_480_11313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2497 24H7.74967C7.37967 24 7.06467 23.73 7.00867 23.364L6.00867 16.864C5.97567 16.648 6.03767 16.427 6.18067 16.261C6.32367 16.095 6.53067 16 6.74967 16H17.2497C17.4687 16 17.6767 16.096 17.8187 16.262C17.9607 16.428 18.0237 16.648 17.9907 16.865L16.9907 23.365C16.9347 23.73 16.6197 24 16.2497 24V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8C14.2091 8 16 6.20914 16 4C16 1.79086 14.2091 0 12 0C9.79086 0 8 1.79086 8 4C8 6.20914 9.79086 8 12 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2173 13C23.0583 10.783 21.8663 8.731 19.9993 7.49C19.9943 6.666 19.3253 6 18.5003 6C17.6723 6 17.0003 6.672 17.0003 7.5C17.0003 8.328 17.6723 9 18.5003 9C18.7743 9 19.0273 8.921 19.2483 8.793C20.6553 9.762 21.5643 11.315 21.7173 13H19.9403C19.5803 10.74 17.6203 9 15.2503 9H8.75028C6.38028 9 4.42028 10.74 4.06028 13H0.750275C0.219275 13 -0.123725 13.538 0.040275 14.01L2.04028 19.51C2.15028 19.8 2.43028 20 2.75028 20H4.47028L4.03028 17.17C3.91028 16.37 4.14028 15.57 4.66028 14.96C5.10628 14.425 5.89528 14 6.75028 14H17.2503C18.0053 14 18.7673 14.311 19.3403 14.96C19.8603 15.57 20.0903 16.37 19.9703 17.17L19.5303 20H21.2503C21.5703 20 21.8503 19.8 21.9603 19.51L23.9603 14.01C24.1183 13.555 23.8163 13 23.2173 13V13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_11313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicSpeaking);
export default __webpack_public_path__ + "static/media/public_speaking.1f6417e3102cf65a9dab72da62e3b2ee.svg";
export { ForwardRef as ReactComponent };